module.exports = __webpack_public_path__ + "static/media/calendar.f58d90e0.svg";